import React from "react";
// import "./Footer.scss";
import { FiMail, FiLinkedin } from "react-icons/fi";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
const Footer = () => {
  return (
    // <footer className="footer">
    //   <div className="container">
    //     <div className="footer__content">
    //       {/* <div className="footer__brand">
    //         <img src="./images/footer-logo.png" alt="FROI_logo" width={300} />
    //         {/* <h3>Zino Labs</h3> */}
    //       {/* <p>Where Ideas Become Code</p> */}
    //       {/* </div> */}
    //       <div className="footer__social">
    //         <a
    //           // href="mailto:info@froiglobal.org"
    //           href="https://mail.google.com/mail/?view=cm&fs=1&to=info@froiglobal.org"
    //           target="_blank"
    //           className="social-link"
    //           aria-label="mail"
    //         >
    //           <span>
    //             <FiMail />
    //           </span>
    //         </a>
    //         <a
    //           href="https://www.linkedin.com/company/froi-future-ready-organization-institute®/"
    //           className="social-link"
    //           aria-label="LinkedIn"
    //           target="_blank"
    //         >
    //           <span>
    //             <FiLinkedin />
    //           </span>
    //         </a>
    //         {/* <a href="#" className="social-link" aria-label="GitHub">
    //           <span>GH</span>
    //         </a> */}
    //       </div>
    //     </div>
    //     <div className="footer__bottom">
    //       <p>© 2026 FROI. All rights reserved.</p>
    //     </div>
    //   </div>
    // </footer>
    <footer className="froi-footer">
      <Container className="froi-footer__container">
        <Row className="row">
          {/* Navigation */}
          <Col lg={5} md={5} xs={12}>
            <div className="froi-footer__links">
              <div className="froi-footer__column">
                <a href="/">Home</a>
                <a href="/froi-about">About</a>
                <a href="/froi-accreditation">Accreditation</a>
                <a href="/froi-certification">Certification™</a>
              </div>

              <div className="froi-footer__column">
                <a href="/froi-global-index">Global Index</a>
                <a href="/froi-model">FROI’s Model</a>
                {/* <a href="/froi-center">FROI’s Center</a> */}
                <a href="/contact">Get in touch</a>
              </div>
            </div>
          </Col>

          {/* Social */}
          <Col lg={2} md={2} xs={12}>
            <div className="froi-footer__social">
              <a
                href="https://www.linkedin.com/company/froi-future-ready-organization-institute®/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FiLinkedin />
              </a>

              <Link to="/contact">
                <FiMail />
              </Link>
            </div>
          </Col>

          {/* Logo / Brand */}
          <Col lg={5} md={5} xs={12}>
            <div className="home_froi-footer__brand">
              <img
                src="./images/Footer/full_name_logo_footer.png"
                alt="FROI"
                className="froi-footer__logo home_footer_logo"
              />
            </div>
          </Col>
        </Row>

        {/* Divider */}
        <div className="froi-footer__divider" />

        {/* Copyright */}
        <div className="froi-footer__copyright">
          © 2026 FROI. All rights reserved.
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
